export const getHideContactSelect = state => state.taskOptions.hideContactSelect;
export const getHidePropertySelect = state => state.taskOptions.hidePropertySelect;
